import { render, staticRenderFns } from "./TabletBlacklist.vue?vue&type=template&id=36d5eb4e&scoped=true"
import script from "./TabletBlacklist.vue?vue&type=script&lang=js"
export * from "./TabletBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5eb4e",
  null
  
)

export default component.exports